import { useCallback } from 'react';

import { useFeatureFlag } from '@/hooks/useFeatureFlag';

export const IOWA_SHIP_FROM_SITE_ID = '8e229164-4c97-de11-8de3-0019d18a6560';

type SemenLabShipment = {
  hasSemen?: boolean | null;
  shipFromSiteId?: string | null;
};

export function useShouldPromptSemenLab() {
  const iaOnly = useFeatureFlag('shipping_show_report_params_dialog');

  return useCallback(
    (shipments: SemenLabShipment[]) => {
      const semenShipments = shipments.filter(
        (shipment) => !!shipment?.hasSemen,
      );

      if (!semenShipments.length) return false;
      if (!iaOnly) return true;

      return semenShipments.some(
        (shipment) =>
          shipment.shipFromSiteId?.toLowerCase() === IOWA_SHIP_FROM_SITE_ID,
      );
    },
    [iaOnly],
  );
}
